import React, { Component } from 'react';
import PropTypes from 'prop-types';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import LabelsStyles from './__styles__/Labels.styles';
import Package from './Package';

class HandlingUnit extends Component {
  static propTypes = {
    unit: PropTypes.object.isRequired,
    shipment: PropTypes.object.isRequired,
    totUnits: PropTypes.number.isRequired
  };

  _createPackages = unit => {
    // create an array for this unit that contains one element for each
    // package in the unit.  E.g, if it's 3 pallets we'll create 3 elements
    // that duplicate the unit.  This is soley just to make things easier
    // to work with.
    const numPackages = unit.unitCount;
    const packageArray = [];
    for (let x = 1; x <= numPackages; x++) {
      packageArray.push(unit);
    }
    return packageArray;
  };

  render() {
    const { unit, shipment, totUnits } = this.props;
    const packageArray = this._createPackages(unit);

    return (
      <div>
        {packageArray.map((item, itemIndex) => {
          return (
            <Package
              key={itemIndex}
              shipment={shipment}
              unit={unit}
              itemIndex={itemIndex}
              totPackages={packageArray.length}
              totUnits={totUnits}
            />
          );
        })}
      </div>
    );
  }
}

export default withStyles(
  combineStyles(LabelsStyles, TypographyStyles, LayoutStyles, SpacingStyles)
)(HandlingUnit);
